<div class="h-100">
  <div class="clients-tab flex align-items-center w-100 border--bottom-grey padding-xxl-20">
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Client name</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Address</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Website</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Contact person</div>
    <div class="font--xxl-11 font-500 color-sky-blue">Phone number</div>
    <div class="flex-1 font--xxl-11 font-500 color-sky-blue">Email</div>
    <div></div>
  </div>
  <div class="body-all overflow-y--scroll">
    <div *ngIf="isLoading" class="w-100 h-100 loader">
      <app-loader class="w-100 h-100"></app-loader>
    </div>
    <div *ngIf="clients && clients.length > 0 && !isLoading" class="h-100">
      <div
        *ngFor="let client of clients"
        class="clients-tab flex align-items-center body-all-one border--bottom-grey position-relative padding-xxl--left-20 padding-xxl--right-20"
      >
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">{{ client?.name }}</div>
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
          <ng-container *ngIf="client?.address; else notProvided">
            {{ client?.address | address }}
          </ng-container>
          <ng-template #notProvided>Not provided</ng-template>
        </div>

        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
          {{ client?.website || '-' }}
        </div>
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
          {{ client?.contactPerson || '-' }}
        </div>
        <div class="font--xxl-13 font-regular color-dark-blue">{{ client?.phone || '-' }}</div>
        <div class="flex-1 font--xxl-13 font-regular color-dark-blue">{{ client?.email || '-' }}</div>
        <div (click)="showPopupDots(client.id)" class="cursor-pointer margin-xxl--right-25">
          <img src="/assets/images/icons/dots.svg" alt="" />
        </div>
        <!-- dots -->
        <div
          [ngStyle]="{
            opacity: openDots && clientId === client.id ? '1' : '0',
            'pointer-events': openDots && clientId === client.id ? 'all' : 'none'
          }"
          (mouseleave)="openDots = false"
          class="dots flex flex-column justify-content-center"
        >
          <div
            (click)="onEditClient(client)"
            class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer"
          >
            Edit Client
          </div>
          <div
            (click)="deleteSelectedClient(client)"
            class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer"
          >
            Delete Client
          </div>
        </div>
      </div>
    </div>
    <!-- empty screen clients-->
    <div *ngIf="(!clients || clients.length === 0) && !isLoading" class="flex justify-content-center">
      <div class="empty-screen flex flex-column align-items-center justify-content-center">
        <img class="margin-xxl--bottom-48" src="/assets/images/emptyScreen/templates.svg" alt="" />
        <div class="font--xxl-16 font-regular text-center color-dark-blue">Here, you’ll find all of your Clients.</div>
        <div class="font--xxl-16 font-regular text-center color-dark-blue margin-xxl--bottom-24">
          You can create a Client Template to generate detailed reports. These Templates also save you a lot of time
          when filling in forms.
        </div>
        <div class="font--xxl-16 font-regular text-center color-dark-blue">
          Add your first Client via the plus symbol in the top-right corner.
        </div>
        <div class="font--xxl-16 font-regular text-center color-dark-blue">
          In order to see clients, please type in the search field.
        </div>
      </div>
    </div>
  </div>
</div>
